import { Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BUILD_INFO } from "../../../../environments/build-info";
import { HistoryService } from '../../../services/history.service';
import { SnackbarComponent } from '../../misc/snackbar/snackbar.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-settings',
    imports: [
        MatToolbarModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        MatSnackBarModule,
        MatProgressSpinnerModule
    ],
    templateUrl: './settings.component.html',
    styleUrl: './settings.component.scss'
})
export class SettingsComponent {
    readonly router = inject(Router);
    readonly historyService = inject(HistoryService);
    readonly _snackBar = inject(MatSnackBar);
    readonly loading = signal(false);

    build = BUILD_INFO;

    buttonItems = [
        { label: 'Target audiences', icon: 'group', key: 'audiences' },
        { label: 'Event Types', icon: 'event', key: 'eventtypes' },
        { label: 'Initiatives', icon: 'rocket_launch', key: 'initiatives' },
        { label: 'Languages', icon: 'translate', key: 'languages' },
        { label: 'Products', icon: 'inventory_2', key: 'products' },
        { label: 'Stakeholder groups for contacts', icon: 'diversity_3', key: 'contactStakeholderGroups' },
        { label: 'Stakeholder groups for organisations', icon: 'diversity_3', key: 'orgStakeholderGroups' },
        { label: 'Topics of interest', icon: 'lightbulb', key: 'generalTopicsOfInterest' },
        { label: 'Topics of interest for members', icon: 'lightbulb', key: 'memberTopicsOfInterest' }
    ].sort((a, b) => a.label.localeCompare(b.label));

    buttonMiscItems = [
        { label: 'Get history report', icon: 'history', key: 'history_report' },

    ].sort((a, b) => a.label.localeCompare(b.label));

    onButtonClick(key: string) {
        console.log('Clicked:', key);
        // your logic here
        switch (key) {
            case ('history_report'):
                this.loading.set(true);
                this.historyService.getHistoryReport().subscribe({
                    next: (response) => {
                        this.loading.set(false);
                        const contentDisposition = response.headers.get('Content-Disposition');
                        console.debug(response.headers);
                        let filename = `history_report.xlsx`;
                        console.debug("contentDisposition", contentDisposition);
                        if (contentDisposition) {
                            const match = contentDisposition.match(/filename="?([^"]+)"?/);
                            if (match && match[1]) {
                                filename = match[1];
                            }
                        }

                        const blob = new Blob([response.body!], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        });

                        const blobUrl = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = blobUrl;
                        a.download = filename;
                        a.click();
                        window.URL.revokeObjectURL(blobUrl);
                    },
                    error: (e) => {
                        this.loading.set(false);
                        console.error('error generating report', e);
                        this._snackBar.openFromComponent(SnackbarComponent, {
                            data: {
                                message: `⚠️ Error generating report`,
                                link: undefined
                            },
                            duration: 2000
                        });
                    }
                });
                break;
            case ('eventtypes'):
            case ('initiatives'):
            case ('languages'):
            case ('generalTopicsOfInterest'):
            case ('memberTopicsOfInterest'):
                // Flat Data: only id and name
                this.router.navigate(['/settings', key]);
                break;
            case ('audiences'):
            case ('products'):
            case ('contactStakeholderGroups'):
            case ('orgStakeholderGroups'):
                // Hierchical data
                this.router.navigate(['/settings', key]);
                break;
            default:
                console.error('invalid button key', key);
                this._snackBar.openFromComponent(SnackbarComponent, {
                    data: {
                        message: `⚠️ Unhandled action`,
                        link: undefined
                    },
                    duration: 2000
                });
        }
    }

}
